import { customRef } from 'vue'

/*
Call the function returned from this one to debounce

https://www.joshwcomeau.com/snippets/javascript/debounce/#usage-2
*/
export const debounce = (callback: (...args: any[]) => any, wait: number) => {
  let timeoutId: number | undefined;

  return (...args: any[]) => {
    window.clearTimeout(timeoutId);

    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
}

export function useDebouncedRef(value: any, delay: number = 200) {
  let timeout: number | undefined;
  return customRef((track, trigger) => {
    return {
      get() {
        track()
        return value
      },
      set(newValue) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          value = newValue
          trigger()
        }, delay)
      }
    }
  })
}